import React from 'react';
import ReactDOM from 'react-dom';

import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/animate.min.css';
import './assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0';

import DNSO from './components/DNS/dns-offline.js';
import './assets/css/main.css';
import './assets/css/demo.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import {createStore} from 'redux';
import {Provider} from 'react-redux';

import AdminLayout from 'layouts/Admin.js';
import Delete from './views/Delete';
import Login from './views/Login';
import Reset from './views/Reset';
import Confirm from './views/Confirm';
import Register from './views/Register';
import DNA from 'views/DNA';
import MultiappEvent from 'views/unlogged_pages/Events/MultiappEvent';
import MultiappEventSport from 'views/unlogged_pages/Events/MultiappEventSport';
import MultiappEventBeauty from 'views/unlogged_pages/Events/MultiappEventBeauty';
import MultiappReservation from 'views/unlogged_pages/Réunion/MultiappReservation';
import DNASigned from 'views/DNASigned';
import allReducers from './reducers/index';
import Footer from './components/Footer/Footer';
import {isMobile} from 'react-device-detect';
// import AesEncryption from 'aes-encryption';

import './i18n';

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
    // const aes = new AesEncryption();
    // aes.setSecretKey('c29ded0b5366c3f2afa66c3cb966f751fecf8ad309a1ecb9e81f3e34dcf2b278');
    // // Note: secretKey must be 64 length of only valid HEX characters, 0-9, A, B, C, D, E and F
    // return JSON.parse(aes.decrypt(serializedState));
  } catch (e) {
    return undefined;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);

    // const aes = new AesEncryption();
    // aes.setSecretKey('c29ded0b5366c3f2afa66c3cb966f751fecf8ad309a1ecb9e81f3e34dcf2b278');
    // // Note: secretKey must be 64 length of only valid HEX characters, 0-9, A, B, C, D, E and F
    // localStorage.setItem('state', aes.encrypt(serializedState));
  } catch (e) {
    return undefined;
  }
};

const peristedState = loadState();

const store = createStore(allReducers, peristedState);

store.subscribe(() => {
  saveState(store.getState());
});

// eslint-disable-next-line
import axios from 'components/Axios/Axios';


// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter
        forceRefresh={true}
      >
        <Switch>
          { store.getState().token['tokenRedux'] != '' ?
          <Route path="/resident" render={(props) => <AdminLayout {...props} />} /> :
          <Redirect from='/resident' to='/login' />
          }
          <Route path="/DNA" render={(props) => <DNA {...props} />} />
          <Route path="/SIGNEDNA" render={(props) => <DNASigned {...props} />} />
          {/* <Route path="/MultiAppEvent" render={(props) => <MultiappEvent {...props} />} /> */}
          { store.getState().token['tokenRedux'] == '' ?
          window.location.href.includes(DNSO + '/register') == true ? <Route path="/register" render={(props) => <Register {...props} />} /> :
          window.location.href.includes(DNSO + '/deleteAccount') == true ? <Route path="/deleteAccount" render={(props) => <Delete {...props} />} /> :
           window.location.href == DNSO + '/resetPassword' ? <Route path="/resetPassword" render={(props) => <Reset {...props} />} /> :
           window.location.href.includes(DNSO + '/confirmReset') == true ? <Route path="/confirmReset" render={(props) => <Confirm {...props} />} /> :
           window.location.href.includes(DNSO + '/MultiAppEvenement') == true ? <Route path="/MultiAppEvenement" render={(props) => <MultiappEvent {...props} />} /> :
           window.location.href.includes(DNSO + '/MultiAppSport') == true ? <Route path="/MultiAppSport" render={(props) => <MultiappEventSport {...props} />} /> :
           window.location.href.includes(DNSO + '/MultiAppBeauty') == true ? <Route path="/MultiAppBeauty" render={(props) => <MultiappEventBeauty {...props} />} /> :
           window.location.href.includes(DNSO + '/MultiappReservation') == true ? <Route path="/MultiappReservation" render={(props) => <MultiappReservation {...props} />} /> :
          <Route path="/login" render={(props) => <Login {...props} />} />: <Redirect from='/*' to='/resident/home' />
          }
          <Route path="*">
            <Redirect to='login' />
          </Route>
        </Switch>
        {console.log('here', window.location.pathname)}
        {
          !isMobile && window.location.pathname != '/login' &&
          <Footer />
        }
      </BrowserRouter>
    </Provider>,
    document.getElementById('root'),
);
